import React from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import * as Actions from './redux-actions.js'
import * as globals from './globals.js'

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  root: {display: props => props.styleDisplay},
}));


function Alert(props) {
  const classes = useStyles(props)  
  return <MuiAlert className={classes.root} elevation={6} variant="filled" {...props} />;
}


function MessageBar(props) {
  const alert = useSelector(state => state.alert) || props.alert
  const dispatch = useDispatch()

  if (! alert) {
 	  return null
  }

 let severityColor
 let barStyle

 if (alert.visible) {
    barStyle = 'flex'
 } else {
 	  barStyle = 'none'
 }


 switch(alert.type) {
 	case globals.ERRO:
 	     severityColor = 'error'
 	     break;
 	case globals.INFO:
 	     severityColor = 'success'
 	     break;
 	case globals.WARN:
 	     severityColor = 'warning'
 	     break;
 	default:
 	     severityColor = 'success'
 }


  return (

      <Snackbar open={alert.visible} anchorOrigin={{ vertical: 'top', horizontal: 'left' }}>
        <Alert severity={severityColor} styleDisplay={barStyle} onClose={()=>dispatch({type: Actions.SET_ALERT, alert: {visible: false }})}>
          {alert.message}
        </Alert>
      </Snackbar>

    )

}


export default MessageBar
